// src/pages/LogoutPage.jsx
import { useEffect, useContext, useState, useRef } from "react";
import { AuthContext } from "../../../providers/AuthProvider";
import { useRouteError } from "../../../errors/ErrorRouteContext";
import { useUserLogout } from "../hooks/authHooks";
// import { useNavigate } from "react-router-dom";

// import "../assets/styles/authentication.css";

export default function LogoutPage() {
  // const { logout } = useUserLogout();
  const logout = useUserLogout({ routeErrors: true });
  const { isLoggedIn } = useContext(AuthContext);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const ran = useRef(false);
  const { showErrorPage } = useRouteError();

  useEffect(() => {
    if (!isLoggedIn) {
      setSuccess("You have successfully logged out.");
      return; // only when actually logged in
    }
    if (ran.current) return; // prevent duplicate calls (StrictMode, re-runs)
    ran.current = true;
    (async () => {
      try {
        // A page that prefers routing on failure:

        // await logout(); // on failure it routes to /error automatically

        const { status, data } = await logout();
        if (data?.success ?? false) {
          setSuccess(data?.message ?? "You have successfully logged out.");
        }
      } catch (err) {
        // showErrorPage({
        //   title: "Action failed",
        //   message: err?.message ?? "Unexpected error",
        //   status: err?.status,
        //   detail: err?.data,
        //   // onRetry: () => doSomething(),
        //   backTo: "/",
        // });
        setError(
          "There was an error in logging you out. Error: " + err?.message
        );
      }
    })();
  }, [isLoggedIn, showErrorPage, logout]);

  // const navigate = useNavigate();

  // useEffect(async () => {
  //   await logout().finally(() => navigate("/login", { replace: true }));
  // }, [logout, navigate]);

  // useEffect(() => {
  //   if (!isLoggedIn) return;
  //   async function fetchData() {
  //     try {
  //       // only if logged in
  //       if (isLoggedIn) {
  //         const result = await logout();
  //         console.log(result);
  //         if (result?.success ?? false)
  //           setSuccess("You have successfully logged out.");
  //       }
  //     } catch (e) {
  //       // setError(e?.message || "Failed to log out.");
  //       setError("There was an error in logging you out. Error: " + e?.message);
  //     } finally {
  //       // setLoading(false);
  //       // navigate("/login", { replace: true });
  //     }
  //   }
  //   fetchData();
  // }, [logout, navigate, isLoggedIn]); // Or [] if effect doesn't need props or state

  return (
    <div>
      <h2>Logout</h2>
      {success && (
        <p className="status success" role="status">
          {success}
        </p>
      )}
      {error && (
        <p className="status error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

// 8/29/25: A
// import React, { useEffect, useRef, useState } from "react";
// import { useUserLogout } from "../../api/auth/UserAuth";

// function LogoutPage() {
//   // If your hook returns a function directly, change to: const logout = useUserLogout();
//   const { logout } = useUserLogout();

//   const [loading, setLoading] = useState(true);
//   const [success, setSuccess] = useState("");
//   const [error, setError] = useState("");

//   const runLogout = async () => {
//     setLoading(true);
//     setSuccess("");
//     setError("");
//     try {
//       // Disable redirect here to avoid navigating back to /logout.
//       alert("logout");
//       const result = await logout({ redirectTo: null });
//       const ok = typeof result === "boolean" ? result : !!result?.success;
//       ok
//         ? setSuccess("You have been logged out.")
//         : setError("Failed to log out.");
//     } catch (e) {
//       setError(e?.message || "Failed to log out.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // useEffect(() => {
//   //   if (ranOnce.current) return; // guard against Strict Mode double-invoke
//   //   ranOnce.current = true;
//   //   runLogout();
//   // }, []); // intentionally empty: we only want this once

//   useEffect(() => {
//     let ran = false;
//     if (!ran) {
//       ran = true;
//       logout({ redirectTo: null }).then(
//         () => setSuccess("You have been logged out."),
//         (e) => setError(e.message)
//       );
//     }
//   }, [logout]);

//   return (
//     <main className="main-content">
//       <h2>Logout</h2>

//       {loading && <p>Logging you out…</p>}
//       {!loading && success && (
//         <p className="status success" role="status">
//           {success}
//         </p>
//       )}
//       {!loading && error && (
//         <p className="status error" role="alert">
//           {error}
//         </p>
//       )}

//       {!loading && (
//         <button type="button" onClick={runLogout}>
//           Run logout again
//         </button>
//       )}
//     </main>
//   );
// }

// export default LogoutPage;

//Orig
// import React from "react";

// function LogoutPage() {
//   return (
//     <main className="main-content">
//       <h2>You are logged out!</h2>
//     </main>
//   );
// }

// export default LogoutPage;
